export default __webpack_public_path__ + "static/media/check.258b03f9.svg";